export const createLunaCanonicalItems = () => [];
